import { render, staticRenderFns } from "./collapsible-product-grid.vue?vue&type=template&id=6d0e90b6&"
import script from "./collapsible-product-grid.vue?vue&type=script&lang=js&"
export * from "./collapsible-product-grid.vue?vue&type=script&lang=js&"
import style0 from "./collapsible-product-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports